import { Flex, Typography } from 'antd'
import React, { useMemo } from 'react'
import {
    colorBgErrorHovered,
    colorBgSuccessHovered,
    colorBorderInfo,
    success,
} from 'src/app/themes/primaryThemeDefault'

export interface IActionTag {
    action: string
}

const ActionTag: React.FC<IActionTag> = (props) => {
    const { action } = props

    const getConfig = useMemo(() => {
        switch (action) {
            case 'Added':
                return {
                    color: success,
                    backgroundColor: colorBgSuccessHovered,
                }
            case 'Modified':
                return {
                    color: colorBorderInfo,
                    backgroundColor: '#EDF9FF',
                }
            case 'Deleted':
                return {
                    color: '#D92D20',
                    backgroundColor: colorBgErrorHovered,
                }
            default:
                return {
                    color: '#46515A',
                    backgroundColor: '#F2F4F7',
                }
        }
    }, [action])

    if (!action) {
        return null
    }

    return (
        <Flex
            style={{
                borderRadius: 27,
                padding: '4px 12px',
                backgroundColor: getConfig.backgroundColor,
                width: 'fit-content',
                alignItems: 'center',
                gap: 4,
            }}
        >
            <div
                style={{
                    backgroundColor: getConfig.color,
                    minWidth: 4,
                    width: 4,
                    height: 4,
                    borderRadius: 50,
                }}
            />
            <Typography
                style={{
                    color: getConfig.color,
                    fontSize: 14,
                    fontWeight: 700,
                    wordBreak: 'keep-all',
                }}
            >
                {action}
            </Typography>
        </Flex>
    )
}

export default ActionTag
